import React from 'react';
import moment from 'moment-jalaali';
import cloneDeep from 'lodash/cloneDeep';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { withFormik, FormikProps, FormikValues, isNaN } from 'formik';
import { startOfDate, endOfDate } from 'utils/date';
import { IUsers, RootState } from 'store/store';
import UniqueBox from './UniqueBox';
import { PeriodLoading } from './PeriodTypeSelector/styles';
import PeriodTypeSelector, {
  IOffset,
} from './PeriodTypeSelector/PeriodTypeSelector';
import Icon from 'components/Icon';
import { display } from 'components/ErrorView/ErrorDialog';
import { LoadingIcon } from 'components/LoadingIcon/LoadingIcon';
import {
  Container,
  CanIFillStatus,
  CanIFillLoading,
  DistinctiveForm,
  CanIFillContainer,
  DuplicateAnswerIcon,
  DistinctiveHintText,
} from './styles';
import { getFilterdQuestions } from 'components/SurveyResponses/ResponseForm/ResponseForm';
import CompanyMemberSelect from '../CompanyMemberSelect/CompanyMemberSelect';
import { InputContainer } from 'components/Select/styles';
import LoadingCircleIndicator from '../../../../../LoadingCircleIndicator/LoadingCircleIndicator';
import { floor } from 'lodash';
import { removeDuplicates } from 'utils/happyFunctions';
import { appDispatch } from 'store/store';
import {
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyResponseView,
  ISurveyView,
  TimeScale,
} from 'store/survey/surveyTypes';
import { ISurveyItem, VisibilityStrategy } from 'store/survey/surveyTypes';
import { IAnalyticsQuery } from 'store/entity/IAnalyticsQuery';
import { IAnalyticResponse } from 'store/entity/IAnalyticResponse';
import { IProviders, ITags } from 'store/providers/providerTypes';
import { ICompany } from 'store/companies/companiesTypes';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { IQueryBucket } from 'store/entity/IQueryBucket';
import { IQueryFilter } from 'store/entity/IQueryFilter';
import { IQueryMetric } from 'store/entity/IQueryMetric';
import {
  canIFill,
  canIFillFn,
  getAnalyse,
  getAnalyseFn,
  requireResponseWithId,
} from 'store/survey/surveySlice';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import {
  getCompanyFn,
  getCompanyHandler,
} from 'store/companies/companiesSlice';
import { NumberOrNull, TimeScaleValues } from 'store/entity/types';
import i18n, {
  getCalendarLocal,
  getLangBaseOnLocal,
} from '../../../../../../i18n';
import { isANumber } from '../../../../../../utils/number';
import { ILocal } from '../../../../../Chart/BaseDatePicker';
import { getPropByPath } from '../../../../../../store/objectHelpers';
// import { getPropByPath } from '../../../../../../store/objectHelpers';

moment.locale('fa');
moment.loadPersian({ dialect: 'persian-modern' });

interface IDispatchToProps {
  canIFill: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem,
    includeDraft?: boolean
  ) => ReturnType<typeof canIFillFn>;
  getAnalyse: (
    dataQuery: IAnalyticsQuery,
    token: string,
    reportToken?: string
  ) => ReturnType<typeof getAnalyseFn>;
  requireSeveralUser: (
    usersList: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
  getCompany: (companyId: number) => ReturnType<typeof getCompanyFn>;
}

interface IOwnProps {
  limitRelatedUsers?: number[];
  tags?: ITags;
  extraTagIds?: number[];
  visibilityStrategy?: VisibilityStrategy;
  questions: { [questoinId: number]: IMultipleChoiceQuestionView };
  periodType: TimeScale;
  version: string;
  surveyItem: ISurveyItem;
  responseId?: number;
  randomInput?: boolean;
  isAnonymous: boolean;
  forceAnalyse: boolean | undefined;
  analyseComplete: () => void;
  setChoicesValue: (values: FormikValues) => void;
  showResponseForm: boolean;
  surveyAnswerList: any;
  onFilterResponses: (filters: IAnalyticsQuery['filters']) => void;
  handleSubmitButton: (disabled: boolean, loading: boolean) => void;
  showDistinctiveForm: boolean;
  filterOnResponseForm?: boolean;
  responseEffectiveDate?: number;
  selectedInstance?: number;
  onSetDistinctiveLabels: (
    labelChanges?: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[]
  ) => void;
  currentUserCompanyRoles: number[];
  distinctiveValues?: { [key: string]: string };
  viewingPeriodType?: TimeScale;
  setViewingPeriodType: (e: TimeScale) => void;
  response?: ISurveyResponseView;
  userRoles?: number[];
  survey: ISurveyView;
  extraFilters: IQueryFilter[];
  providers: IProviders;
  onSelectResponse?: (responseId: number) => void;
  dataSourceValues?: { [key: string]: string };
}
interface IStateToProps {
  users: IUsers['map'];
  company: ICompany;
  companyId?: NumberOrNull;
  thisUser: IThisUserState;
  offset: IOffset | null;
}
type IComponentProps = IOwnProps & IDispatchToProps & IStateToProps;

interface IDistinctiveState {
  checkDuplicate: boolean; // waiting for canIFill response
  getOldResponse: boolean | undefined;
  loadingAnalyse: boolean; // TODO
  preventSendResponse: number | undefined; // -1 cant send; can send ; 1+ cant send due to duplicate
  userNotInAllowedSenders: boolean | undefined; // response of canIFill request
  allQuestionsAnswered: boolean; // true when all questions answered
  updatedValuesWithUserInteractions: boolean; // true when all questions answered
  validOptions?: { [key: number]: number[] };
  noValidPeriodFound?: boolean;
}

interface IQuestionsCounts {
  [questionId: string]: { [questionValue: string]: number };
}

export interface IPeriodCounts {
  [momentValue: string]: number;
}

export interface IDistinctiveLabel {
  value: string;
  label: string;
  order: number;
}

class DistinctiveQuestion extends React.PureComponent<
  IComponentProps & FormikProps<FormikValues>
> {
  state: IDistinctiveState = {
    checkDuplicate: false,
    getOldResponse: undefined,
    loadingAnalyse: false,
    preventSendResponse: undefined,
    userNotInAllowedSenders: false,
    allQuestionsAnswered: false,
    updatedValuesWithUserInteractions: false,
  };
  internalValues = {};

  handleSetValues(
    setValues: (
      values: React.SetStateAction<FormikValues>,
      shouldValidate?: boolean
    ) => void,
    newValues: any,
    byUser?: boolean
  ) {
    this.internalValues = newValues;
    setValues(newValues);
    if (byUser) {
      this.setState({ updatedValuesWithUserInteractions: true });
    }
  }
  // getAnalyse for all questions (buckets => empty)
  componentDidMount() {
    this.props.handleSubmit();
    this.handleCanIFill(false, false);
    if (this.props.surveyItem.instanceType === 'User' && !this.props.company) {
      this.props.getCompany(this.props.companyId!);
    }
    this.setState({ periodType: this.props.periodType || 'month' });
    this.componentDidUpdate({} as any);
  }

  componentWillUnmount() {
    this.props.handleSubmitButton(false, false);
  }

  componentDidUpdate(prevProps: FormikProps<FormikValues> & IComponentProps) {
    const {
      values,
      resetForm,
      setValues,
      questions,
      periodType,
      responseId,
      randomInput,
      viewingPeriodType,
      tags,
      forceAnalyse,
      handleSubmit,
      analyseComplete,
      setChoicesValue,
      surveyAnswerList,
      showDistinctiveForm,
      responseEffectiveDate,
      showResponseForm,
      onSetDistinctiveLabels,
      surveyItem,
      thisUser,
      selectedInstance,
      visibilityStrategy,
    } = this.props;
    this.internalValues = values;
    const currentQuestionIds = Object.keys(values);
    const missingQuestionsInValues = Object.keys(questions).filter(
      (qId) => !currentQuestionIds.includes(qId.toString())
    );
    if (missingQuestionsInValues.length > 0) {
      missingQuestionsInValues.forEach((id) => {
        values[id] = undefined;
      });
      this.handleSetValues(setValues, { ...values });
    }
    // survey edit mode // TODO define type for temp
    if (
      (surveyAnswerList && !this.state.getOldResponse) ||
      (surveyAnswerList && prevProps.responseId !== responseId)
    ) {
      const useTags = Object.values(questions).reduce(
        (temp: any, question: IMultipleChoiceQuestionView | undefined) => {
          temp[question!.id] = question!.useTags;
          return temp;
        },
        {}
      );
      const allDistinctive: FormikValues = Object.keys(surveyAnswerList).reduce(
        (obj: FormikValues, key: string) => {
          const { selected, value, values } = surveyAnswerList[key];
          obj[key] = useTags[key]
            ? selected.length > 0
              ? selected.join(',')
              : null
            : value || values?.[0] || null;
          return obj;
        },
        {}
      );
      if (responseId) {
        allDistinctive.instance = selectedInstance;
      }

      // pass effectiveDate to handleSaveResponse in SurveyResponseViewer
      if (periodType && responseEffectiveDate) {
        const response = {
          currentDate: new Date(responseEffectiveDate), // set currentDate
          [periodType]: Math.floor(responseEffectiveDate),
        };
        this.handleSetValues(
          setValues,
          Object.assign(allDistinctive, response)
        );
      } else {
        this.handleSetValues(setValues, allDistinctive);
      }
      this.setState({ getOldResponse: true });
    }
    // fill instance if type=karbar and not public and no change data token available
    const canChangeUser =
      !responseId &&
      ((showResponseForm && surveyItem.changeDataToken) ||
        (!showResponseForm && surveyItem.reportToken) ||
        !visibilityStrategy ||
        visibilityStrategy === 'open');

    if (
      !responseId &&
      (!values.instance ||
        (!canChangeUser && values.instance !== thisUser.userId)) &&
      surveyItem.instanceType === 'User'
    ) {
      const userId = Number(thisUser.userId);

      const company = this.props.company;
      const member =
        company &&
        company.members &&
        userId &&
        company.members[thisUser.userId!];

      if (
        !surveyItem.targetRolesIds ||
        surveyItem.targetRolesIds.length === 0 ||
        (member &&
          Object.keys(member.roles).find((roleId) => {
            return surveyItem!.targetRolesIds!.includes(Number(roleId));
          }))
      ) {
        if (!canChangeUser && userId !== values.instance)
          this.handleChangeRelatedUser(userId, false);
      } else this.setState({ userNotInAllowedSenders: !canChangeUser });
    }
    // setDefaultValues if needed
    if (!responseId && !prevProps.showResponseForm && showResponseForm) {
      const newValues = cloneDeep(values);
      let updateValues = false;
      Object.entries(questions).forEach((qItem) => {
        const question = qItem[1];
        if (question.readFromItemTag) {
          newValues[qItem[0]] = this.props.surveyItem.tags.find(
            (it) =>
              question.tagChoices?.includes(+it.id!) ||
              (question.parentTagChoices?.includes(it.parentId!) &&
                !question.excludedTagChoices?.includes(+it.id))
          )?.id;
          updateValues = true;
        } else if (
          question.defaultValue?.length > 0 &&
          values[qItem[0]] !== question.defaultValue?.[0]
        ) {
          newValues[qItem[0]] = question.defaultValue?.[0];
          updateValues = true;
        } else if (randomInput) {
          let choices: IMultipleChoiceQuestionView['choiceList'] = [];
          if (question.useTags && tags) {
            // todo: parent tags could be null instead of array
            if (question.parentTagChoices) {
              question.parentTagChoices.forEach((parentId: number) => {
                //todo should check for null
                Object.values(tags)
                  .filter(
                    (tag: any) =>
                      tag.parentId === parentId &&
                      !tag.deleted &&
                      !question.excludedTagChoices?.includes(tag.id)
                  )
                  .sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
                  .map((item: any) => choices.push(item.id));
              });
            }
            if (question.tagChoices) {
              question.tagChoices.forEach((tagChoice: number) => {
                choices.push(tagChoice as any);
              });
            }
            // number[]
            choices = removeDuplicates(choices).map((it) => {
              return {
                value: it,
              } as any;
            });
          } else {
            choices = question.choiceList;
          }
          const choice =
            choices[Math.floor(Math.random() * choices.length)]?.value;
          newValues[qItem[0]] = choice?.toString();
          updateValues = true;
        } else if (
          !this.props.randomInput &&
          !surveyItem.changeDataToken &&
          question.fields?.find((it) => it.name === 'conf_dataSourceField')
        ) {
          let propByPath = getPropByPath(
            this.props.dataSourceValues,
            question.fields!.find((it) => it.name === 'conf_dataSourceField')!
              .value
          ) as string;

          const mapConvert = question.fields?.find(
            (it) => it.name === 'conf_dataSourceConvertMap'
          )?.value;
          if (mapConvert && propByPath) {
            propByPath = JSON.parse(mapConvert)[propByPath];
          }
          if (propByPath) {
            if (question.useTags) newValues[qItem[0]] = Number(propByPath);
            else newValues[qItem[0]] = propByPath;
            updateValues = true;
          }
        }
      });
      if (randomInput) {
        if (viewingPeriodType) {
          newValues[viewingPeriodType] = new Date().getTime();
          updateValues = true;
        }
        if (surveyItem.instanceType === 'User') {
          // this.handleChangeRelatedUser(Number(thisUser.get('userId')), true);
          newValues.instance = Number(thisUser.userId);
          updateValues = true;
        }
      }
      if (updateValues) this.handleSetValues(setValues, newValues);
    }
    // request canIFill when values changed & all questions answered on distinctiveForm
    if (setChoicesValue && prevProps.values !== values) {
      setChoicesValue(values);
      // if (showDistinctiveForm) {
      // show add response button, return undefined when all questions answered
      const find = Object.entries(values).find(
        // item value is null and (is not a question or  in distinctive questions)
        (item) =>
          item[1] === null &&
          (isNaN(Number(item[0])) || questions[item[0]]) &&
          (!TimeScaleValues.includes(item[0]) || item[0] === periodType)
      );
      const allDestinctiveQuestionsAnswered =
        find === undefined &&
        (surveyItem.instanceType !== 'User' || !!values.instance);
      this.handleCanIFill(allDestinctiveQuestionsAnswered, showDistinctiveForm);
      // }
    }
    // request canIFill when all questions answered and on click on add response button
    if (
      showDistinctiveForm &&
      !prevProps.showDistinctiveForm &&
      !surveyAnswerList
    ) {
      TimeScaleValues.forEach((e) => {
        if (e !== periodType) {
          delete values[e];
        }
      });
      const allQuestionsAnswered =
        !Object.values(values).includes(null) &&
        (surveyItem.instanceType !== 'User' || !!values.instance);
      this.handleCanIFill(allQuestionsAnswered, showDistinctiveForm);
    }
    // if (!showDistinctiveForm) {
    //   this.setState({ allQuestionsAnswered: true });
    //   this.handleCanIFill(true, showDistinctiveForm);
    // }
    if (forceAnalyse) {
      resetForm();
      onSetDistinctiveLabels(); // to clear distinctiveLabels
      handleSubmit(); // getAnalyse for all questions
      analyseComplete(); // tell the parent component to set forceAnalyse state => false
    }
  }
  handleChangeRelatedUser = (
    userId: number | undefined,
    pushLabelChanges: boolean = true,
    byUser: boolean = false
  ) => {
    const {
      values,
      setValues,
      isAnonymous,
      handleSubmit,
      showResponseForm,
      showDistinctiveForm,
      onSetDistinctiveLabels,
      users,
    } = this.props;

    const newValues = cloneDeep(values);
    newValues.instance = userId;
    this.handleSetValues(setValues, newValues, byUser);
    const labelChanges: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[] = [];

    const name = i18n.t('relatedUser', { ns: 'modals' });
    if (!isAnonymous) {
      if (userId)
        labelChanges.push({
          distinctiveLabelItem: {
            value: name,
            label: users[userId].name as string,
            order: -1, // to sort selected distinctive labels
          },
          show: true,
        });
      else
        labelChanges.push({
          distinctiveLabelItem: {
            value: name,
            label: '',
            order: -1,
          },
          show: true,
        });
    }
    if (pushLabelChanges) onSetDistinctiveLabels(labelChanges);
    // getAnalyse when no form is shown
    if (!(showResponseForm || showDistinctiveForm || isAnonymous)) {
      handleSubmit();
    }
  };
  handleChangeValues = (e: React.ChangeEvent<HTMLInputElement>, level = 0) => {
    const {
      // values,
      setValues,
      isAnonymous,
      handleSubmit,
      showResponseForm,
      showDistinctiveForm,
      onSetDistinctiveLabels,
      filterOnResponseForm,
      questions,
      survey,
      response,
    } = this.props;

    const {
      name,
      value,
      checked,
      dataset: { label, order },
    } = e.target;

    // Manually clone and update full values for filtering logic
    const newValues = cloneDeep(this.internalValues);
    newValues[name] = checked
      ? level === 0
        ? value
        : `${newValues?.[name]?.split(',').slice(0, level)},${value}`
      : level === 0
        ? null
        : `${newValues?.[name]?.split(',').slice(0, level)}`;

    const filteredQuestionsData = getFilterdQuestions(
      questions,
      newValues,
      survey,
      response
    );
    const filteredQuestionIds = filteredQuestionsData.map((q) => q.id);

    const labelChanges: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[] = [];

    Object.keys(newValues).forEach((key) => {
      const qId = Number(key);
      if (!isNaN(qId) && !filteredQuestionIds.includes(qId)) {
        newValues[key] = undefined;
        labelChanges.push({
          distinctiveLabelItem: {
            value: qId.toString(),
            label: '',
            order: 0, // to sort selected distinctive labels
          },
          show: false,
        });
      }
    });
    this.handleSetValues(setValues, newValues, e.target instanceof HTMLElement);
    if (!isAnonymous) {
      labelChanges.push({
        distinctiveLabelItem: {
          value: name,
          label: label as string,
          order: Number(order), // to sort selected distinctive labels
        },
        show:
          checked &&
          (!questions[Number(name)]?.readFromItemTag ||
            !this.props.surveyItem.upstreamItemId),
      });
    }
    onSetDistinctiveLabels(labelChanges);
    // getAnalyse when no form is shown
    if (
      !(showResponseForm || showDistinctiveForm || isAnonymous) ||
      filterOnResponseForm
    ) {
      handleSubmit();
    }
  };
  handleChangeOptions = (key: number, options: number[]) => {
    const {
      values,
      setValues,
      isAnonymous,
      handleSubmit,
      showResponseForm,
      showDistinctiveForm,
      onSetDistinctiveLabels,
      filterOnResponseForm,
    } = this.props;
    const newValues = cloneDeep(values);
    const validOptions = newValues.validOptions || {};
    newValues.validOptions = validOptions;
    validOptions[key] = options;
    newValues[key] = undefined;
    this.handleSetValues(setValues, newValues);
    const labelChanges: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[] = [];
    labelChanges.push({
      distinctiveLabelItem: {
        value: key.toString(),
        label: '',
        order: 0, // to sort selected distinctive labels
      },
      show: false,
    });
    onSetDistinctiveLabels(labelChanges);
    if (
      !(showResponseForm || showDistinctiveForm || isAnonymous) ||
      filterOnResponseForm
    ) {
      handleSubmit();
    }
  };

  handleChangeDate =
    (addOrSubtract: 'add' | 'subtract' | 'reset') => (value?: number) => {
      const {
        values,
        periodType: propPeriodType,
        viewingPeriodType,
        setValues,
        isAnonymous,
        handleSubmit,
        showResponseForm,
        showDistinctiveForm,
      } = this.props;
      const periodType = showResponseForm
        ? propPeriodType
        : viewingPeriodType || propPeriodType;
      const newValues = cloneDeep(values);
      const getCurrentDate = values.currentDate;
      let newDate;
      if (!(showResponseForm && showDistinctiveForm) && values[periodType]) {
        newValues[periodType] = null;
      }
      if (addOrSubtract === 'reset') {
        newDate = value ? new Date(value) : new Date();
      } else {
        switch (periodType) {
          case 'day':
          case 'week':
            //
            newDate = moment(getCurrentDate) // eslint-disable-next-line no-unexpected-multiline
              [addOrSubtract](1, 'jMonth')
              .toDate();
            break;
          case 'month':
          case 'season':
          case 'twoSeason':
            newDate = moment(getCurrentDate) // eslint-disable-next-line no-unexpected-multiline
              [addOrSubtract](1, 'jYear')
              .toDate();
            break;
          case 'year':
            newDate = moment(getCurrentDate) // eslint-disable-next-line no-unexpected-multiline
              [addOrSubtract](5, 'jYear')
              .toDate();
            break;
        }
      }
      newValues.currentDate = newDate;
      this.handleSetValues(setValues, newValues, true);
      if (!(showResponseForm || showDistinctiveForm || isAnonymous)) {
        handleSubmit();
      }
    };

  handleCanIFill = (allQuestionsAnswered: boolean, checkUnique: boolean) => {
    const {
      values,
      canIFill,
      questions,
      periodType,
      version,
      responseId,
      surveyItem,
      handleSubmitButton,
    } = this.props;

    this.setState({ allQuestionsAnswered });
    handleSubmitButton(
      !allQuestionsAnswered,
      allQuestionsAnswered && checkUnique
    );
    if (!checkUnique) return;
    if (allQuestionsAnswered) {
      this.setState({ checkDuplicate: true });

      const distinctiveAnswers: any = [];
      // make new IMultipleChoiceAnswer from values for canIFill request
      Object.values(questions).forEach(
        (question: IMultipleChoiceQuestionView | undefined) => {
          const questionId: number = question!.id;
          if (question!.useTags) {
            const selected = values[questionId]?.toString()?.split(',');
            distinctiveAnswers.push({
              type: 'multipleChoice',
              selected,
              questionId,
              description: null,
            });
          } else {
            distinctiveAnswers.push({
              type: 'multipleChoice',
              value: values[questionId],
              questionId,
              description: null,
            });
          }
        }
      );

      const response: ISurveyResponseView = {
        id: responseId && responseId, // for update previous response
        title: null,
        surveyId: surveyItem.surveyId,
        // if survey has periodType, add effectiveDate to request
        effectiveDate: periodType && values[periodType] * 1,
        surveyAnswerList: distinctiveAnswers,
        instance: values.instance,
        surveyVersion: version,
        tags: [
          ...surveyItem.tags.map((it) => Number(it.id)),
          ...(this.props.extraTagIds || []),
        ],
      };

      const singleDraft = this.props.survey.surveyType !== 'Exam'; //  !!this.props.survey.fields?.find(
      // (it) => it.name === 'conf_singleDraft' && it.value === 'true'
      // );
      canIFill(response, surveyItem, singleDraft)
        .then((res) => {
          const survey = this.props.survey;
          if (
            (survey.surveyType === 'Exam' &&
              !surveyItem.reportToken &&
              survey.fillDurationInMinutes &&
              res.duplicateAnswerId) ||
            (singleDraft && res.duplicateAnswerId)
          ) {
            appDispatch(
              requireResponseWithId({
                surveyItemData: surveyItem,
                responseId: res.duplicateAnswerId,
                includeDeletedResponse: false,
              })
            )
              .then(() => {
                const found = survey.responseMap?.[res.duplicateAnswerId];
                if (
                  found &&
                  (found.submitDate! + survey.fillDurationInMinutes! * 60_000 >
                    new Date().valueOf() ||
                    singleDraft) &&
                  (!this.state.updatedValuesWithUserInteractions ||
                    confirm(
                      i18n.t('prevResponseExistWantToUpdate', { ns: 'survey' })
                    ))
                ) {
                  this.props.onSelectResponse?.(found!.id!);
                  handleSubmitButton(false, false);
                  this.setState({
                    checkDuplicate: false,
                    preventSendResponse: false,
                    hasDuplicateAnswer: false,
                  });
                } else {
                  handleSubmitButton(!!res.duplicateAnswerId, false);
                  this.setState({
                    checkDuplicate: false,
                    preventSendResponse: res.duplicateAnswerId,
                    hasDuplicateAnswer: !!res.duplicateAnswerId,
                  });
                }
              })
              .catch(() => {
                handleSubmitButton(!!res.duplicateAnswerId, false);
                this.setState({
                  checkDuplicate: false,
                  preventSendResponse: res.duplicateAnswerId,
                  hasDuplicateAnswer: !!res.duplicateAnswerId,
                });
              });
          } else {
            handleSubmitButton(!!res.duplicateAnswerId, false);
            this.setState({
              checkDuplicate: false,
              preventSendResponse: res.duplicateAnswerId,
              hasDuplicateAnswer: !!res.duplicateAnswerId,
            });
          }
        })
        .catch((err: any) => {
          handleSubmitButton(true, false);
          this.setState({ checkDuplicate: false, preventSendResponse: -1 });
          display(err);
        });
    }
  };

  render() {
    const {
      tags,
      status,
      values,
      questions,
      periodType: propPeriodType,
      isAnonymous,
      isSubmitting,
      showResponseForm,
      showDistinctiveForm,
      responseEffectiveDate,
      visibilityStrategy,
      surveyItem,
      users,
      responseId,
      currentUserCompanyRoles,
      company,
      viewingPeriodType,
      response,
      userRoles,
      thisUser,
      survey,
      version,
    } = this.props;
    const ignorePeriodForUser =
      !surveyItem.reportToken &&
      !propPeriodType &&
      !!survey.fields?.find((it) => it.name === 'conf_ignorePeriodForUser');
    const periodType = showResponseForm
      ? propPeriodType
      : ignorePeriodForUser
        ? undefined
        : viewingPeriodType || propPeriodType;
    const filterdQuestions = getFilterdQuestions(
      questions,
      values || {},
      survey,
      response
    );
    const {
      checkDuplicate,
      preventSendResponse,
      allQuestionsAnswered,
      userNotInAllowedSenders,
      noValidPeriodFound,
    } = this.state;
    const showCanIFillBox = showResponseForm || showDistinctiveForm;
    const hideCounts = showCanIFillBox || isAnonymous;
    const canIFillStatus: CanIFillStatus =
      userNotInAllowedSenders || noValidPeriodFound
        ? 'reject'
        : allQuestionsAnswered
          ? checkDuplicate
            ? 'idle'
            : preventSendResponse
              ? 'reject'
              : 'allow'
          : 'idle';
    const canChangeUser =
      !responseId &&
      ((showResponseForm && surveyItem.changeDataToken) ||
        (!showResponseForm && surveyItem.reportToken) ||
        !visibilityStrategy ||
        visibilityStrategy === 'open');
    const relatedUserTitle: string =
      survey?.versions?.[version].fields?.find(
        (it) => it.name === 'conf_relatedUserTitle'
      )?.value ||
      (this.props.survey.surveyType === 'Exam'
        ? i18n.t('participant', { ns: 'survey' })
        : i18n.t('selectRelatedUser', { ns: 'modals' }));

    const local = surveyItem.providerId
      ? this.props.providers.map?.[surveyItem.providerId]?.data
          ?.surveyOwnerProperties.localId || getCalendarLocal()
      : getCalendarLocal();

    return (
      <React.Fragment>
        <Container>
          {showResponseForm && (
            <CanIFillContainer status={'idle'}>
              <DuplicateAnswerIcon>
                <Icon type={response?.id ? 'user-check' : 'user-plus'} />
              </DuplicateAnswerIcon>
              <DistinctiveHintText>
                {i18n.t(
                  survey.keepResponsesAnonymous
                    ? 'submitAnonymously'
                    : response?.id
                      ? 'updatingWith'
                      : 'submittingWith',
                  {
                    ns: 'survey',
                    user:
                      thisUser?.name ||
                      thisUser?.userId ||
                      i18n.t('Anonymous', { ns: 'survey' }),
                  }
                )}
              </DistinctiveHintText>
            </CanIFillContainer>
          )}

          {periodType &&
            (status ? (
              <PeriodTypeSelector
                setNoValidPeriodFound={(set?: boolean) => {
                  this.setState({ noValidPeriodFound: set });
                }}
                loading={isSubmitting}
                changeDate={this.handleChangeDate}
                hideCounts={hideCounts}
                periodType={periodType}
                originalPeriodType={propPeriodType}
                setPeriodType={(periodType: TimeScale) => {
                  if (
                    periodType !== this.props.viewingPeriodType &&
                    this.props.viewingPeriodType
                  )
                    delete values[this.props.viewingPeriodType];
                  this.props.setViewingPeriodType(periodType);
                  // setTimeout(() => {
                  this.handleChangeDate('reset')();
                  // }, 300);
                }}
                currentDate={values.currentDate}
                periodCounts={status[periodType]}
                selectedPeriod={values[periodType]}
                onChangeValues={this.handleChangeValues}
                showResponseForm={showResponseForm}
                responseEffectiveDate={responseEffectiveDate}
                surveyItem={surveyItem}
                offset={showResponseForm ? this.props.offset : null}
                local={local}
              />
            ) : (
              <PeriodLoading />
            ))}

          {surveyItem.instanceType === 'User' &&
            (canChangeUser ? (
              this.props.company && this.props.company.members ? (
                <CompanyMemberSelect
                  companyMembers={this.props.company.members}
                  roleIds={surveyItem.targetRolesIds}
                  userIds={this.props.limitRelatedUsers}
                  onSelectUser={(list: any) =>
                    this.handleChangeRelatedUser(
                      list[0] || undefined,
                      true,
                      true
                    )
                  }
                  label={relatedUserTitle}
                  placeholder={i18n.t('selectRelatedUser', { ns: 'modals' })}
                  selected={values.instance ? [values.instance] : []}
                  requireSeveralUser={this.props.requireSeveralUser}
                />
              ) : (
                <LoadingCircleIndicator />
              )
            ) : (
              values.instance && (
                <InputContainer focused={false} disabled={true}>
                  {' '}
                  {
                    (relatedUserTitle +
                      ' : ' +
                      users[values.instance].name) as string
                  }
                </InputContainer>
              )
            ))}
          {filterdQuestions.length > 0 && (
            <DistinctiveForm>
              {filterdQuestions
                .sort((a, b) => a.order - b.order)
                .filter(
                  (x) =>
                    surveyItem.reportToken ||
                    !x.fields?.find((it) => it.name === 'conf_hidden')
                )
                .map((question: IQuestionsView | undefined) => {
                  if (tags)
                    return (
                      <UniqueBox
                        key={question!.id}
                        tags={tags}
                        status={status}
                        values={values}
                        question={question as IMultipleChoiceQuestionView}
                        hideCounts={hideCounts}
                        onChangeValues={this.handleChangeValues}
                        onChangeOptions={this.handleChangeOptions}
                        showResponseForm={showResponseForm}
                        currentUserCompanyRoles={currentUserCompanyRoles}
                        company={company}
                        surveyItem={surveyItem}
                        response={response}
                        userRoles={userRoles}
                        thisUserId={Number(thisUser.userId)}
                        survey={this.props.survey}
                      />
                    );
                  else return null;
                })}
            </DistinctiveForm>
          )}
          {showCanIFillBox && (
            <CanIFillContainer status={canIFillStatus}>
              <DuplicateAnswerIcon>
                {checkDuplicate ? (
                  <LoadingIcon color="white" />
                ) : (
                  <Icon
                    type={
                      userNotInAllowedSenders
                        ? 'x'
                        : allQuestionsAnswered
                          ? preventSendResponse
                            ? 'x'
                            : 'check'
                          : 'alert-circle'
                    }
                  />
                )}
              </DuplicateAnswerIcon>
              <DistinctiveHintText>
                {
                  (userNotInAllowedSenders ? (
                    i18n.t('userNotInAllowedSenders', { ns: 'modals' })
                  ) : noValidPeriodFound ? (
                    i18n.t('noValidPeriodFound', { ns: 'survey' })
                  ) : allQuestionsAnswered ? (
                    checkDuplicate ? (
                      <CanIFillLoading />
                    ) : preventSendResponse === -1 ? (
                      i18n.t('cantSend', { ns: 'modals' })
                    ) : preventSendResponse ? (
                      i18n.t('hasDuplicateAnswer', { ns: 'modals' })
                    ) : (
                      i18n.t('notDuplicate', { ns: 'modals' })
                    )
                  ) : (
                    i18n.t('hintDistinctiveResponse', { ns: 'modals' })
                  )) as string
                }
              </DistinctiveHintText>
            </CanIFillContainer>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

let requestCounter = 0;

const getBucketItemBaseOnLanguage = (
  startMoment: moment.Moment,
  endMoment: moment.Moment,
  gap: number,
  local: 'fa' | 'en' = 'fa'
) => {
  const startTime =
    local === 'fa'
      ? startMoment.jMonth() + startMoment.jYear() * 12
      : startMoment.locale('en').month() + startMoment.locale('en').year() * 12;
  const endTime =
    local === 'fa'
      ? endMoment.jMonth() + endMoment.jYear() * 12 + 1
      : endMoment.locale('en').month() + endMoment.locale('en').year() * 12 + 1;

  const bucketItem: IQueryBucket = {
    name: 'TermByTime',
    type: 'rangeBucket',
    field: 'effectiveJMonth',
    start: startTime,
    end: endTime,
    gap: `${gap}`,
  };

  return bucketItem;
};

const determineStartEndTimeBaseOnPeriodType = (
  selectedPeriod: any,
  periodType: TimeScale,
  currentDate: any,
  local: ILocal = 'fa_IR@calendar=persian'
) => {
  let start;
  let end;
  const lang = getLangBaseOnLocal(local);
  const textFormatMonth = (
    lang === 'fa' ? 'jMonth' : 'month'
  ) as moment.unitOfTime.StartOf;
  const textFormatYear = (
    lang === 'fa' ? 'jYear' : 'year'
  ) as moment.unitOfTime.StartOf;
  if (selectedPeriod) {
    const selectedTimeStamp = selectedPeriod * 1;
    const period =
      lang === 'fa'
        ? moment(selectedTimeStamp)
        : moment(selectedTimeStamp).locale('en');
    switch (periodType) {
      case 'day':
        start = period.startOf('day').valueOf();
        end = period.endOf('day').valueOf();
        break;
      case 'week':
        start = period.startOf('week').valueOf();
        end = period.endOf('week').valueOf();
        break;
      case 'month':
        start = period.startOf(textFormatMonth).valueOf();
        end = period.endOf(textFormatMonth).valueOf();
        break;
      case 'season':
        // eslint-disable-next-line no-case-declarations
        const seasonDate = new Date(selectedTimeStamp);
        start = startOfDate(
          seasonDate,
          'season',
          true,
          getLangBaseOnLocal(local)
        );
        end = endOfDate(seasonDate, 'season', true, getLangBaseOnLocal(local));
        break;
      case 'twoSeason':
        // eslint-disable-next-line no-case-declarations
        const twoSeasonDate = new Date(selectedTimeStamp);
        start = startOfDate(
          twoSeasonDate,
          'twoSeason',
          true,
          getLangBaseOnLocal(local as ILocal)
        );
        end = endOfDate(
          twoSeasonDate,
          'twoSeason',
          true,
          getLangBaseOnLocal(local as ILocal)
        );
        break;
      case 'year':
        start = period.startOf(textFormatYear).valueOf();
        end = period.endOf(textFormatYear).valueOf();
        break;
    }
  } else {
    switch (periodType) {
      case 'day':
        start = moment(currentDate).startOf(textFormatMonth).valueOf();
        end = moment(currentDate).endOf(textFormatMonth).valueOf();
        break;
      case 'week':
        start = moment(currentDate)
          .startOf(textFormatMonth)
          .weekday(-7)
          .valueOf();
        end = moment(currentDate).endOf(textFormatMonth).weekday(+7).valueOf();
        break;
      case 'month':
      case 'season':
      case 'twoSeason':
        start = moment(currentDate).startOf(textFormatYear).valueOf();
        end = moment(currentDate).endOf(textFormatYear).valueOf();
        break;
      case 'year':
        start = moment(currentDate)
          .startOf(textFormatYear)
          .subtract(5, textFormatYear as moment.unitOfTime.DurationConstructor)
          .valueOf();
        end = moment(currentDate).endOf(textFormatYear).valueOf();
        break;
    }
  }

  return [start, end];
};

const formikEnhancer = withFormik<IComponentProps, FormikValues>({
  mapPropsToValues(props) {
    const {
      questions,
      periodType: propPeriodType,
      distinctiveValues,
      showResponseForm,
      viewingPeriodType,
    } = props;
    const periodType = showResponseForm
      ? propPeriodType
      : viewingPeriodType || propPeriodType;
    /* all distinctive question IDs with null choices value { questionId: null } */
    const allDistinctive: FormikValues = Object.values(questions).reduce(
      (temp: any, question: IMultipleChoiceQuestionView | undefined) => {
        temp[question!.id] =
          (props.showResponseForm && question?.defaultValue?.[0]?.toString()) ||
          (distinctiveValues && distinctiveValues[question!.id.toString()]) ||
          null;
        return temp;
      },
      {}
    );
    if (periodType) {
      allDistinctive[periodType] = null;
      if (propPeriodType) allDistinctive[propPeriodType] = null;
      allDistinctive.currentDate = new Date();
    } else if (viewingPeriodType) {
      delete allDistinctive[viewingPeriodType];
    }
    return allDistinctive;
  },

  handleSubmit(
    values: FormikValues,
    { props, resetForm, setStatus, setSubmitting }
  ) {
    setSubmitting(true);
    const local = props.surveyItem.providerId
      ? props.providers.map[props.surveyItem.providerId].data
          ?.surveyOwnerProperties.localId || getCalendarLocal()
      : getCalendarLocal();

    const {
      getAnalyse,
      surveyItem,
      periodType: propPeriodType,
      isAnonymous,
      onFilterResponses,
      showResponseForm,
      viewingPeriodType,
    } = props;
    const periodType = showResponseForm
      ? propPeriodType
      : viewingPeriodType || propPeriodType;
    const {
      [periodType]: selectedPeriod,
      instance,
      currentDate,
      validOptions,
      ...pickedValues
    } = values;
    let useJmonthForTime = false;
    // when user not logged in
    if (isAnonymous) {
      setStatus(
        Object.assign(pickedValues, {
          [periodType]: null,
        })
      );
    } else {
      const buckets: IQueryBucket[] = []; // Store unselectedQuestions
      let filters: IQueryFilter[] = []; // Store selectedQuestions
      const metrics: IQueryMetric[] = [
        {
          name: 'getCount',
          metric: 'count',
        },
      ];

      if (periodType) {
        const hoursGap = {
          day: 24,
          week: 168,
          month: 745,
          season: 2233,
          twoSeason: 4465,
          year: 8766,
        };
        const monthGap = {
          month: 1,
          season: 3,
          twoSeason: 6,
          year: 12,
        };
        // console.log(local);
        // user select one item between start-end of periodType range
        const [start, end] = determineStartEndTimeBaseOnPeriodType(
          selectedPeriod,
          periodType,
          currentDate,
          local
        );
        // if (selectedPeriod) {
        //   const selectedTimeStamp = selectedPeriod * 1;
        //   const period = moment(selectedTimeStamp);
        //   switch (periodType) {
        //     case 'day':
        //       start = period.startOf('day').valueOf();
        //       end = period.endOf('day').valueOf();
        //       break;
        //     case 'week':
        //       start = period.startOf('week').valueOf();
        //       end = period.endOf('week').valueOf();
        //       break;
        //     case 'month':
        //       start = period.startOf('jMonth').valueOf();
        //       end = period.endOf('jMonth').valueOf();
        //       break;
        //     case 'season':
        //       // eslint-disable-next-line no-case-declarations
        //       const seasonDate = new Date(selectedTimeStamp);
        //       start = startOfDate(seasonDate, 'season', true);
        //       end = endOfDate(seasonDate, 'season', true);
        //       break;
        //     case 'twoSeason':
        //       // eslint-disable-next-line no-case-declarations
        //       const twoSeasonDate = new Date(selectedTimeStamp);
        //       start = startOfDate(twoSeasonDate, 'twoSeason', true);
        //       end = endOfDate(twoSeasonDate, 'twoSeason', true);
        //       break;
        //     case 'year':
        //       start = period.startOf('jYear').valueOf();
        //       end = period.endOf('jYear').valueOf();
        //       break;
        //   }
        // } else {
        //   switch (periodType) {
        //     case 'day':
        //       start = moment(currentDate).startOf('jMonth').valueOf();
        //       end = moment(currentDate).endOf('jMonth').valueOf();
        //       break;
        //     case 'week':
        //       start = moment(currentDate)
        //         .startOf('jMonth')
        //         .weekday(-7)
        //         .valueOf();
        //       end = moment(currentDate).endOf('jMonth').weekday(+7).valueOf();
        //       break;
        //     case 'month':
        //     case 'season':
        //     case 'twoSeason':
        //       start = moment(currentDate).startOf('jYear').valueOf();
        //       end = moment(currentDate).endOf('jYear').valueOf();
        //       break;
        //     case 'year':
        //       start = moment(currentDate)
        //         .startOf('jYear')
        //         .subtract(5, 'jYear')
        //         .valueOf();
        //       end = moment(currentDate).endOf('jYear').valueOf();
        //       break;
        //   }
        // }

        if (periodType === 'day' || periodType === 'week') {
          const gapBasedOnDay = hoursGap[periodType];

          const bucketItem: IQueryBucket = {
            name: 'TermByTime',
            type: 'dateRangeBucket',
            field: 'effectiveDate',
            start: null,
            end: null,
            gap: `+${gapBasedOnDay}HOURS`,
          };
          buckets.push(bucketItem);
        } else {
          useJmonthForTime = true;
          const startMoment = moment(start);
          const endMoment = moment(end);
          const gapBasedOnMonth = monthGap[periodType];
          // const bucketItem: IQueryBucket = {
          //   name: 'TermByTime',
          //   type: 'rangeBucket',
          //   field: 'effectiveJMonth',
          //   start: startMoment.jMonth() + startMoment.jYear() * 12,
          //   end: endMoment.jMonth() + endMoment.jYear() * 12 + 1,
          //   gap: `${gapBasedOnMonth}`,
          // };

          const bucketItem: IQueryBucket = getBucketItemBaseOnLanguage(
            startMoment,
            endMoment,
            gapBasedOnMonth,
            local === 'fa_IR@calendar=persian' ? 'fa' : 'en'
          );
          buckets.push(bucketItem);
        }
        const timeFilter: IQueryFilter = {
          type: 'dateRangeFilter',
          field: 'effectiveDate',
          start,
          end,
        };
        filters.push(timeFilter);
      }
      if (props.extraTagIds?.length) {
        filters = [
          ...filters,
          ...props.extraTagIds.map(
            (it) =>
              ({
                type: 'termFilter',
                field: 'tags',
                values: [it],
              }) as IQueryFilter
          ),
        ];
      }
      // add instance to filter
      if (instance) {
        filters.push({
          type: 'termFilter',
          field: 'instance',
          values: [instance.toString()],
        });
      }
      // Get unselected/selected questions
      Object.entries(pickedValues).forEach(([key, value]) => {
        if (!value) {
          buckets.push({
            name: `${key}`,
            type: 'bucket',
            field: 'allAnswers',
            prefix: `${key}$$`,
          });
        } else {
          filters.unshift({
            type: 'termFilter',
            field: 'allAnswers',
            values:
              value?.split(',')?.length > 1
                ? value?.split(',')?.map((el: string) => `${key}$$${el}`)
                : [`${key}$$${value}`],
            operator: 'AND',
          });
        }

        if (
          value &&
          (props.questions[Number(key)].distinctive ||
            props.questions[Number(key)].showInTitle) &&
          (props.questions[Number(key)].goDeepInTags || 0) > 0
        ) {
          buckets.push({
            name: `${key}`,
            type: 'bucket',
            field: 'allAnswers',
            prefix: `${key}$$`,
          });
        }
      });

      // add valid options
      if (validOptions)
        Object.entries(validOptions).forEach(([key, value]) => {
          if (value)
            filters.unshift({
              type: 'termFilter',
              field: 'allAnswers',
              values: (value as number[]).map((v) => `${key}$$${v}`),
            });
        });

      const analyseQuery: IAnalyticsQuery = {
        filters: [...filters, ...(props.extraFilters || [])],
        buckets,
        metrics,
      };

      const token =
        surveyItem.editToken ||
        surveyItem.changeDataToken ||
        surveyItem.reportToken ||
        surveyItem.fillToken;
      ++requestCounter;
      const myCount = requestCounter;
      Promise.all([
        getAnalyse(analyseQuery, token, surveyItem.extraOwnerTokens?.[0]),
        onFilterResponses(analyseQuery.filters),
      ])
        .then((responses) => {
          if (requestCounter !== myCount) return;
          const { categories, metrics: allMetrics } = responses[0]?.result;
          let periodTypeCounts;
          let selectedQuestions = {};
          let unselectedQuestions = {};
          // If user select all questions or no analyse found then categories will be null
          if (categories) {
            const { TermByTime, ...questionCategories } = categories;
            const questionsCounts = Object.keys(questionCategories).reduce(
              (temp: IQuestionsCounts, questionId: string) => {
                const { buckets: dBuckets } = questionCategories[questionId];
                const counts = dBuckets.reduce(
                  (
                    total: { [choiceValue: string]: number },
                    choice: IAnalyticResponse
                  ) => {
                    total[(choice.val as string).split('$$')[1]] =
                      choice.metrics.getCount;
                    return total;
                  },
                  {}
                );
                temp[questionId] = counts;
                return temp;
              },
              {}
            );
            unselectedQuestions = questionsCounts;
            if (TermByTime) {
              periodTypeCounts = TermByTime.buckets.reduce(
                (temp: IPeriodCounts, bucket: any) => {
                  const momentValue = useJmonthForTime
                    ? local === 'fa_IR@calendar=persian'
                      ? moment()
                          .jMonth(Number(bucket.val) % 12)
                          .jYear(floor(Number(bucket.val) / 12))
                          .jDate(1)
                          .hour(0)
                          .minutes(0)
                          .seconds(0)
                          .milliseconds(0)
                          .valueOf()
                      : moment()
                          .locale('en')
                          .month(Number(bucket.val) % 12)
                          .year(floor(Number(bucket.val) / 12))
                          .date(1)
                          .hour(0)
                          .minutes(0)
                          .seconds(0)
                          .milliseconds(0)
                          .valueOf()
                    : moment(bucket.val).valueOf();
                  temp[momentValue] = bucket.metrics.getCount;
                  return temp;
                },
                {}
              );
            }
          }
          if (allMetrics) {
            let selectedValues: IQueryFilter[];
            if (periodType) {
              selectedValues = filters.filter(
                (filter) => filter.type === 'termFilter'
              );
            } else {
              selectedValues = filters;
            }
            const { count } = allMetrics;
            selectedQuestions = Object.keys(selectedValues).reduce(
              (temp: IQuestionsCounts, key: string) => {
                const { values: dValues, field } = selectedValues[key];
                if (dValues && field === 'allAnswers') {
                  const [questionId, value] = dValues[0].split('$$');
                  const selectedQuestionsCounts: {
                    [questionValue: string]: number;
                  } = {};
                  selectedQuestionsCounts[value] = count;
                  temp[questionId] = selectedQuestionsCounts;
                }
                return temp;
              },
              {}
            );
            // Merge all selectedQuestions & unselectedQuestions and set into Formik Status
            setStatus(
              Object.assign(selectedQuestions, unselectedQuestions, {
                [periodType]: periodTypeCounts,
              })
            );
          } else {
            setStatus(Object.assign(pickedValues));
          }
          setSubmitting(false);
        })
        .catch((err) => {
          resetForm();
          setSubmitting(false);
          // this.setState({ loadingAnalyse: false });
          display(err);
        });
    }
  },
});

const UniqueQuestion: any = formikEnhancer(DistinctiveQuestion);

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    canIFill: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem,
      includeDraft
    ) => appDispatch(canIFill({ response, surveyItemData, includeDraft })),
    getAnalyse: (
      dataQuery: IAnalyticsQuery,
      token: string,
      reportToken?: string
    ) =>
      appDispatch(getAnalyse({ dataQuery, surveyToken: token, reportToken })),
    requireSeveralUser: (usersList: number[]) =>
      appDispatch(requireSeveralUser({ usersList })),
    getCompany: (companyId: number) =>
      appDispatch(
        getCompanyHandler({
          companyId,
          templateStub: true,
          companyStub: false,
          projectStub: true,
        })
      ),
  };
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const users = state.users.map;
  const thisUser = state.thisUser;
  const providerId = props.surveyItem.providerId;
  const provider = state.providers.map[providerId];
  const companyId = provider.data?.managingCompanyId;
  const company: ICompany = state.companies.data[companyId!];
  // if it does not have offset do nothing (act as normal)
  const fillValidPeriod = props.survey.fillValidPeriod;
  const userHaveChangePermission = props.surveyItem.changeDataToken || null;
  const offset =
    (isANumber(fillValidPeriod.fromOffsetDaysRelativeToStartOfPeriod) ||
      isANumber(fillValidPeriod.toOffsetDaysRelativeToEndOfPeriod)) &&
    !userHaveChangePermission
      ? ({
          start: fillValidPeriod.fromOffsetDaysRelativeToStartOfPeriod,
          end: fillValidPeriod.toOffsetDaysRelativeToEndOfPeriod,
        } as IOffset)
      : null;

  return {
    users,
    company,
    thisUser,
    companyId,
    offset,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UniqueQuestion);
